module.exports = __webpack_public_path__ + "img/icon-tests-menu-covid.ff55ec52.svg";